/* eslint-disable prettier/prettier */
import React from 'react';

type LabelProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export const Label = ({ className = '', children, ...props }: LabelProps) => {
  return (
    <label className={`block text-m mx-1 my-1 text-primary ${className}`} {...props}>
      {children}
    </label>
  );
};
